varying vec3 fragmentNormal;
varying vec2 fragmentUV;

varying float light;
varying float backLight;

varying vec3 fragmentColor;

uniform sampler2D shootTexture;
uniform vec3 shootTextureColorA;
uniform vec3 shootTextureColorB;

uniform vec3 shootTextureTint;
uniform float shootTextureAlpha;

uniform float shootTextureWeight;

// vec3 hueShift(vec3 color, float hue) // {
//   const vec3 k = vec3(0.57735, 0.57735, 0.57735);
//   float cosAngle = cos(hue);
//   return vec3(color * cosAngle + cross(k, color) * sin(hue) + k * dot(k, color) * (1.0 - cosAngle));
// }

void main() {

  vec4 color = vec4(1,1,1,1);
  vec2 uv = fragmentUV;

  // Directional light.
  float faceLight = mix(light,backLight,(gl_FrontFacing) ? .1: .90);
  color.rgb *= faceLight;// .15 + (.85 * faceLight);

  // Ambient light.
  color.rgb += vec3(.1,.1,.1);

  // Tinted texture.
  vec4 shootTextureColor = texture2D(shootTexture, uv);
  vec3 shootTextureGradient = mix(shootTextureColorA, shootTextureColorB, shootTextureColor.r);

  color.rgb *= mix(shootTextureGradient,shootTextureColor.rgb,shootTextureWeight);  

  // Add shadow ramp.
  color.rgb *= clamp(uv.y + .75, 0.,1.);

  // Tint
  color.rgb *= shootTextureTint;

  // Masked alpha
  float alpha = (1.-shootTextureColor.g) + (shootTextureAlpha *2.-1.);

  // Base alpha
  color.a = mix(1., alpha, shootTextureWeight);

  // Fragment color.
  color.rgb *= fragmentColor;

  // Return final color.
  gl_FragColor = color;// vec4(color.a,color.a,color.a,1.);
}